import React,{Fragment} from 'react';
import styled from 'styled-components';
import IncrementaVentasCoheteSvg from "../../svg/Prueba";
import Prueba2 from "../../svg/Prueba2"
import MarketingRedesSvg from "../../svg/MarketinRedes";


const Servicios = () => {
    return ( 
<Fragment>
        <H3>Servicios</H3>

        <DivServicios>

            <DivSvgServ>
                 <IncrementaVentasCoheteSvg/>
                     <span>Desarrollo de sitios web</span>
                     <p>Creamos páginas web y landing pages atractivas, modernas, optimizadas, responsivas y compatibles con computadoras de escritorio y dispositivos móviles (smartphones y tablets).</p>
            </DivSvgServ>
            
            
            <DivSvgServ>
                 <Prueba2/>
                     <span>Estrategia de marketing e Ecommerce</span>
                     <p>Un sitio web con e-commerce es una tienda abierta las 24 horas para tus potenciales clientes.</p>
            </DivSvgServ>

            <DivSvgServ>
            <MarketingRedesSvg/>
                     <span>Marketing en redes sociales</span>
                     <p>La publicidad en redes sociales es indispensable si estás buscando llegar a un público nuevo y específico de forma rápida..</p>
            </DivSvgServ>
            
            
          
        </DivServicios>
</Fragment>

     );
}
 
export default Servicios;




const H3 = styled.h3`

text-transform: uppercase;
letter-spacing: 0.5em;
text-align: center;
margin: 20px auto;
color: #7B7554;
font-size: 1.5em;


`


const DivServicios = styled.div`

display: grid;
grid-template-columns: repeat(3,1fr);
width: 100%;
@media(max-width:668px){
grid-template-columns: repeat(2,1fr);
    
}

@media(max-width:568px){
grid-template-columns: repeat(1,1fr);
    
}



`


const DivSvgServ = styled.div`


width: 60%;
margin: 10px auto;
display: flex;
flex-direction: column;


span{
    margin: 20px auto;
    letter-spacing: 0.2em;
    text-align: center;
    color: #E63946;
    font-weight: 700;
}


p{
    text-align: center;
    letter-spacing: 0.1em;
    margin: 0;


}






`
